export default __webpack_public_path__ + "static/media/arrow-left.205edc45.svg";